import { Formik, FieldArray } from 'formik';
import { Grid, TextField, Box, Button, List, Divider } from 'components/ui';
import { WideForm } from 'components/styles_components/form';
import { FormattedMessage, useIntl } from 'react-intl';
import { TitleTypography } from 'components/styles_components/typography';
import DatePicker from 'components/form/date_picker';
import ResultSelect from 'components/form/result_select';
import InspectionFieldExecuteItem from 'components/inspection_field/execute_item';
import validationSchema from 'validation/inspection/execute';
import { nextDueDate } from 'utils/inspection';

const ExecuteForm = ({ initialValues, processing, onSubmit, onCancel, periodCycle, periodNumber }) => {
  const intl = useIntl();

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema()} onSubmit={onSubmit}>
      {(formik) => (
        <WideForm onSubmit={formik.handleSubmit}>
          <DatePicker
            className="full-width margin-top-10"
            name="doneAt"
            id="doneAt"
            label={intl.formatMessage({ id: 'form.inspection.input.done_at' })}
            value={formik.values.doneAt}
            onChange={(value) => {
              formik.setFieldValue('doneAt', value);
              formik.setFieldValue('dueDate', nextDueDate(value, periodCycle, periodNumber));
            }}
          />
          <DatePicker
            className="full-width margin-top-10"
            name="dueDate"
            id="dueDate"
            label={intl.formatMessage({ id: 'form.inspection.input.next_due_date' })}
            value={formik.values.dueDate}
            onChange={(value) => formik.setFieldValue('dueDate', value)}
          />
          <Grid className="margin-top-10">
            <ResultSelect
              className="full-width"
              name="result"
              id="result"
              label={intl.formatMessage({ id: 'form.inspection.input.result' })}
              value={formik.values.result}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={(formik.touched.result && Boolean(formik.errors.result)) || undefined}
              helperText={formik.touched.result && formik.errors.result}
            />
          </Grid>
          {formik.values.inspectionFields.length > 0 &&
          <>
            <Divider />
            <TitleTypography>
              <FormattedMessage id="form.inspection.section.inspection_fields" />
            </TitleTypography>
            <FieldArray
              name="inspectionFields"
              validateOnChange={false}
              render={() => (
                <List>
                  {formik.values.inspectionFields.map((obj, index) => (
                    <InspectionFieldExecuteItem
                      key={obj.id ?? index}
                      index={index}
                      obj={obj}
                      processing={processing}
                      setFieldValue={formik.setFieldValue}
                    />
                  ))}
                </List>
              )}
            />
          </>}
          <Divider />
          <TitleTypography>
            <FormattedMessage id="form.inspection.section.notes" />
          </TitleTypography>
          <TextField
            autoFocus
            fullWidth
            multiline
            margin="dense"
            id="notes"
            name="notes"
            label={intl.formatMessage({ id: 'form.inspection.input.notes' })}
            value={formik.values.notes}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.notes && Boolean(formik.errors.notes)) || undefined}
            helperText={formik.touched.notes && formik.errors.notes}
          />
          <Button
            fullWidth
            className="margin-top-10"
            disabled={!formik.isValid || processing}
            color="primary"
            variant="contained"
            type="submit"
          >
            <FormattedMessage id="button.save" />
          </Button>
          <Box display="flex" justifyContent="flex-end">
            <Button size="small" variant="text" disabled={processing} onClick={onCancel}>
              <FormattedMessage id="button.cancel" />
            </Button>
          </Box>
        </WideForm>
      )}
    </Formik>
  );
};

export default ExecuteForm;
